import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation, useParams } from 'react-router-dom';

import styles from '../warning-messages/index.module.scss';

import { mfaChallengeSelector } from 'selectors/auth';
import { currentSiteSelector } from 'selectors/root-site';
import { buildSignInPath } from 'constants/route-paths';
import { mfaChallengeForSite } from 'utils/mfa';

// A `required` site refused the session on a private route (403 step-up) but public pages keep
// rendering; this is how the user learns what the site needs and where to do it
const MfaStepUpBanner = () => {
  const { siteSlug } = useParams();
  const location = useLocation();
  const { siteId } = useSelector(currentSiteSelector(siteSlug));
  const challenge = mfaChallengeForSite(useSelector(mfaChallengeSelector), siteId);

  if (!challenge?.stepUp) return null;

  return (
    <p className={styles.warning_message}>
      {challenge.message}&nbsp;
      <Link to={{ pathname: buildSignInPath(siteSlug), state: { from: location } }} className={styles.link_to_setup}>
        {challenge.enrollmentRequired ? 'Set it up' : 'Enter your code'}
      </Link>
    </p>
  );
};

export default MfaStepUpBanner;
